import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import {
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import config from "../../config";
import ReactDOM from "react-dom";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120,
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "100%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
  input: {
    padding: "10px",
    border: "1px solid",
    borderRadius: 2,
    "&:before": {
      borderColor: "red",
    },
    "&:after": {
      borderColor: "white",
    },
  },
});
class MergeBrands extends Component {
  state = {
    brands: [],
    loading: true,
    name: "",
    phone_number: "",
    oldBrand: "",
    oldId: "",
    newBrand: "",
  };

  constructor(props) {
    super(props);
    this.btnSaveOnClick = this.btnSaveOnClick.bind(this);
    this.btnCancelOnClick = this.btnCancelOnClick.bind(this);
  }

  componentDidMount() {
    // console.log("componentDidMount");
    this.listBrands();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  listBrands() {
    axios
      .get(BACKEND_URL + `/brand`)
      .then((response) => {
        this.setState({
          brands: response.data,
          loading: false,
        });
        // console.log(response.data);
      })
      .catch(function (error) {
        // console.log(error);
        //TODO: Show errors with snackbars
      });
  }

  btnCancelOnClick(e) {
    e.preventDefault();
    this.props.history.goBack();
  }

  btnSaveOnClick() {
    const { oldBrand, newBrand } = this.state;
    if (oldBrand && newBrand) {
      if (oldBrand == newBrand) {
        alert(
          "They are the same brands with same Ids. You cannot merge this brand."
        );
      } else {
        const obj = {
          prevId: this.state.oldBrand,
          newId: this.state.newBrand,
        };
        // console.log("Data sending", obj);
        axios({
          method: "post",
          url:
            `${BACKEND_URL}` +
            `/brand/merge/source/${oldBrand}/destination/${newBrand}`,
        })
          .then((res) => {
            // console.log(res);
            if (res.data && res.data.message === "Success") {
              alert("Merged Successfully");
            } else {
              alert("Merged was unsuccessful");
            }
          })
          .catch(
            (e) => {
              // console.log(e);
              // console.log(e.response);
            }
            // alert(`Error: ${e} | Response: ${e.response.data.message}`)
          );
      }
    } else {
      alert("Please select the brands to merge.");
    }
  }

  saveSuccess(response) {
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
    this.props.history.goBack();
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  render() {
    const { classes } = this.props;
    const { oldBrand, newBrand, brands, oldId } = this.state;

    return (
      <div>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ width: "100%" }}
        >
          <Grid
            align="center"
            justify="space-evenly"
            container
            alignItems="center"
          >
            <Grid xs={8}>
              <Typography
                variant="h4"
                style={{ marginTop: "2%", marginBottom: "2%" }}
              >
                Merge Brands
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ width: "90%" }}
          >
            <fieldset className={classes.fieldset}>
              <legend className={classes.legend_text}>Brand</legend>
              <Grid container direction="row" justify="space-evenly">
                <Grid
                  container
                  direction="row"
                  justify="space-evenly"
                  style={{ marginLeft: 10 }}
                >
                  <Grid item md={5}>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={oldBrand}
                      style={{ width: "95%" }}
                      onChange={(text) => {
                        this.setState({
                          oldBrand: text.target.value,
                        });
                      }}
                      input={
                        <OutlinedInput classes={{ input: classes.input }} />
                      }
                      className={classes.select}
                      labelWidth={200}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {brands ? (
                        brands.map((data) => (
                          <MenuItem key={data._id} value={data._id}>
                            {data.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={0}>Unexpected Error</MenuItem>
                      )}
                    </Select>
                    <Typography variant="h7" style={{ paddingTop: 10 }}>
                      {oldId}
                    </Typography>
                  </Grid>
                  <Typography variant="h7" style={{ paddingTop: 10 }}>
                    {">"}
                  </Typography>
                  <Grid item md={5}>
                    <Select
                      style={{ width: "95%" }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={newBrand}
                      onChange={(text) => {
                        this.setState({ newBrand: text.target.value });
                      }}
                      input={
                        <OutlinedInput classes={{ input: classes.input }} />
                      }
                      className={classes.select}
                      labelWidth={200}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {brands ? (
                        brands.map((data) => (
                          <MenuItem key={data._id} value={data._id}>
                            {data.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value={0}>Unexpected Error</MenuItem>
                      )}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
            </fieldset>
            <Grid item align="center">
              <Button
                variant="contained"
                type="submit"
                fullWidth
                style={{
                  backgroundColor: "#F6277F",
                  boxShadow: "2",
                  width: 210,
                  marginTop: 50,
                  marginBottom: 50,
                }}
                onClick={() => this.btnSaveOnClick()}
              >
                <Typography variant="h7" className={classes.enter_text}>
                  Merge the brands
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

MergeBrands.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MergeBrands);
